import React, { useEffect, useState } from "react";
import { DatePicker, Button, Space } from "antd";
import moment from "moment";
import axios from "axios"
import { BASE_URL } from "./axios"
import { Office, CircularGrid, ProjectIcon, ContactorIcon, LetterTypee, Calender } from "./ReusableSVGs"
import { sortProjects } from "./ReusableFunctions"
import Select from "react-select";
const { RangePicker } = DatePicker;

const DateRangePicker = ({ startDate, endDate, onChange, placeHolder1, placeHolder2 }) => {
    const [dates, setDates] = useState([null, null]);

    const handleRangeChange = (values) => {
        if (!values || values.length !== 2) {
            setDates(null);
            onChange(null, null);
            return;
        }

        setDates(values);
        onChange(values[0].format("YYYY-MM-DD"), values[1].format("YYYY-MM-DD"));
    };


    return (
        <div>
            <Calender />
            <Space direction="vertical" size={12} style={{ color: "#707070" }}>
                <RangePicker
                    key={dates ? dates.toString() : "empty"}
                    value={dates}
                    placeholder={[placeHolder1, placeHolder2]}
                    onChange={handleRangeChange}
                    className="custom-range-picker"
                />

            </Space>
        </div>
    );
};
const LetterStatus = ({ selectedLetterStatus, setLetterStatus }) => {
    return (
        <div title="Status Filter" className="field-cont-div">
            <CircularGrid />
            <select
                id="status"
                name="status"
                placeholder="Status"
                value={selectedLetterStatus}
                onChange={(e) => setLetterStatus(e.target.value)}
                className={`attendance-input-field width-10vw `}
            >



                <option value="null">Select a Status</option>
                <option value="pending">Pending</option>
                <option value="in-progress">InProgress</option>
                <option value="partially-close">Partially Close</option>
                <option value="close">Close</option>



            </select>
            <hr className="field-cont-hr" />
        </div>
    )
}

const LetterType = ({ setLetterType, lettertype }) => {
    return (
        <>
            <div title="Letter Type" className="field-cont-div">
                <LetterTypee />
                <select
                    onChange={(e) => setLetterType(e.target.value)}
                    value={lettertype}
                    className="attendance-input-field width-10vw   date-field"
                >

                    <option value="null"> Letter Type</option>
                    <option value="eot">EOT</option>
                    <option value="cos">COS</option>
                    <option value="ncr">NCR</option>
                    <option value="billing">Billing</option>
                    <option value="design">Design</option>
                    <option value="informative">Informative</option>
                    <option value="show-cause">Show Cause</option>
                    <option value="Design & Drawing">Design & Drawing</option>
                    <option value="P&P">P&P</option>
                    <option value="QAP">QAP</option>
                    <option value="Structure">Structure</option>
                    <option value="billing">Billing</option>
                    <option value="Q & ME">Q & ME</option>
                    <option value="BBS">BBS</option>
                    <option value="noc">NOC</option>
                    <option value="Road Safety">Road Safety</option>
                    <option value="Work Plan">Work Plan</option>
                    <option value="Drain">Drain</option>
                    <option value="Hydrology">Hydrology</option>
                    <option value="Survey">Survey</option>
                    <option value="Milestone">Milestone</option>
                    <option value="SiteProgress">SiteProgress</option>
                    <option value="query">Query</option>
                    <option value="other">Others</option>
                </select>

                <hr className="field-cont-hr" />
            </div>
        </>
    )
}

const SubCompany = ({ toggleCompany, setToggleCompany }) => {

    const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);

    // Fetch sub-companies when the component mounts
    useEffect(() => {
        const fetchSubCompanies = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/configuration/subcompany/`);
                setSiteSubCompanyList(response.data);
            } catch (error) {
                console.error('Error fetching sub-companies:', error);
            }
        };

        fetchSubCompanies();
    }, []);


    // Event handlers
    const handleCompanyChange = (e) => setToggleCompany(e.target.value);


    return (
        <>

            <div title="Company Filter" className="field-cont-div">
                <Office />
                <select
                    onChange={handleCompanyChange}
                    value={toggleCompany || 'null'}
                    className="attendance-input-field date-field"
                >
                    <option value="null">Sub Company</option>
                    {siteSubCompanyList.map((company) => (
                        <option key={company.id} value={company.id}>
                            {company.title}
                        </option>
                    ))}
                </select>
                <hr className="field-cont-hr" />
            </div>
        </>
    )
}

const Projects = ({ toggleProject, toggleProjectName, setToggleProject, toggleProjectCode, setToggleProjectCode, setToggleProjectName, subcompany, value, title }) => {
    const [projectList, setProjectList] = useState([]);
    const [projectList2, setProjectList2] = useState([]);
    const [projectList3, setProjectList3] = useState([]);

    useEffect(() => {
        if (!subcompany) return;

        const fetchProjects = async () => {
            try {
                const url = `${BASE_URL}/project_details/project/`;

                const response = await axios.get(url);
                const sortedProjects = sortProjects(response.data, "site_prcode");
                if (toggleProject) {
                    setProjectList(
                        sortedProjects.map(({ id, site_prcode, project_short_name }) => ({
                            value: id,
                            label: `${site_prcode}-${project_short_name}`,
                        }))
                    );
                }
                if (toggleProjectName) {
                    setProjectList2(
                        sortedProjects.map(({ id, site_prcode, project_short_name }) => ({
                            value: project_short_name,
                            label: `${site_prcode}-${project_short_name}`,
                        }))
                    );
                }
                if (toggleProjectCode) {
                    setProjectList3(
                        sortedProjects.map(({ id, site_prcode, project_short_name }) => ({
                            value: site_prcode,
                            label: `${site_prcode}-${project_short_name}`,
                        }))
                    );
                }
            } catch (error) {
                console.error("Error fetching projects:", error);
            }
        };

        fetchProjects();
    }, [subcompany]);

    const handleProjectChange = (option) => {
        if (!option) {
            if (value === "id") {
                setToggleProject("null");
            } if (value === "name") {
                setToggleProjectName("");
            }
            if (value === "projectcode") {
                setToggleProjectCode("null");
            }
            return; // Ensure function exits when clearing selection
        }

        if (value === "id") {
            setToggleProject(option.value);
        } if (value === "name") {
            setToggleProjectName(option.value);
        }
        if (value === "projectcode") {
            setToggleProjectCode(option.value);
        }
    };




    console.log("value")
    console.log(value)
    console.log(value, toggleProject, toggleProjectName)

    return (
        <>

            <div title="Project Filter" className="field-cont-div">
                {/* <hr className="field-cont-hr" /> */}

                <ProjectIcon />
                <Select
                    key={toggleProject || toggleProjectName || toggleProjectCode} // Forces re-render
                    className="attendance-input-field  date-field"

                    options={projectList}
                    value={
                        value === "id"
                            ? projectList.find((item) => item.value === toggleProject) || "null"
                            : value === "name"
                                ? projectList2.find((item) => item.value === toggleProjectName) || ""
                                : value === "projectcode" ?
                                    projectList3.find((item) => item.value === toggleProjectCode) || "null"
                                    : "null"
                    }
                    onChange={handleProjectChange}
                    isClearable
                    placeholder="Select Project"
                    styles={{
                        control: (provided) => ({
                            ...provided,
                            backgroundColor: "transparent",
                            border: "none",
                            boxShadow: "none",
                            padding: "0.6rem 0.5rem",
                            textTransform: "capitalize",
                            width: "11vw"
                        }),
                        placeholder: (provided) => ({ ...provided, color: "#707070" }),
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        singleValue: (provided) => ({ ...provided, color: "#707070" }),
                        dropdownIndicator: (provided) => ({
                            ...provided,
                            filter: "invert(50%)",
                            cursor: "pointer",
                            left: "9.5rem",
                            // width: "20px",
                            height: "20px",
                            fontSize: "12px",
                        }),
                        option: (provided, state) => ({
                            ...provided,
                            fontSize: "12px",
                            color: state.isSelected ? "#ffffff" : "#707070",
                            backgroundColor: state.isSelected ? "#2576bc" : state.isFocused ? "#ffffff" : "#fff",
                            cursor: "pointer",
                            "&:hover": { backgroundColor: "#2576bc", color: "#fff" },
                        }),
                    }}
                />

                <hr className="field-cont-hr" />
            </div>
        </>
    );
};

const ContractorFilter = ({ toggleContractor, toggleContractorName, settoggleContractor, settoggleContractorName, project, value }) => {
    const [contractorList, setcontractorList] = useState([]);
    const [contractorList2, setcontractorList2] = useState([]);

    useEffect(() => {
        if (!project) return;

        const fetchContractor = async () => {
            try {
                const res = await axios.get(`${BASE_URL}/project_details/contractorbyproject/${project}/`);
                const contractorData = res.data;

                if (toggleContractor) {
                    setcontractorList(
                        contractorData.map(({ id, name }) => ({
                            value: id,
                            label: `${name}`,
                        }))
                    );
                }
                if (toggleContractorName) {
                    setcontractorList2(
                        contractorData.map(({ id, name }) => ({
                            value: name,
                            label: `${name}`,
                        }))
                    );
                }

            } catch (error) {
                console.error("Error fetching projects:", error);
            }
        };

        fetchContractor();
    }, [project]);

    const handlecontractor = (option) => {
        if (!option) {
            if (value === "id") {
                settoggleContractor("null");
            } if (value === "name") {
                settoggleContractorName("");
            }
            return; // Ensure function exits when clearing selection
        }

        if (value === "id") {
            settoggleContractor(option.value);
        } if (value === "name") {
            settoggleContractorName(option.value);
        }

    };






    return (
        <>

            <div title="Contractor Filter" className="field-cont-div">
                <ContactorIcon />
                <Select
                    key={toggleContractor || toggleContractorName} // Forces re-render
                    className="attendance-input-field  date-field"

                    options={contractorList}
                    value={
                        value === "id"
                            ? contractorList.find((item) => item.value === toggleContractor) || "null"
                            : value === "name"
                                ? contractorList2.find((item) => item.value === toggleContractorName) || ""
                                : "null"
                    }
                    onChange={handlecontractor}
                    isClearable
                    placeholder="Select a Contractor"
                    styles={{
                        control: (provided) => ({
                            ...provided,
                            backgroundColor: "transparent",
                            border: "none",
                            boxShadow: "none",
                            padding: "0.6rem 0.5rem",
                            textTransform: "capitalize",
                            width: "16vw"
                        }),
                        placeholder: (provided) => ({ ...provided, color: "#707070" }),
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        singleValue: (provided) => ({ ...provided, color: "#707070" }),
                        dropdownIndicator: (provided) => ({
                            ...provided,
                            filter: "invert(50%)",
                            cursor: "pointer",
                            left: "9.5rem",
                            // width: "20px",
                            height: "20px",
                            fontSize: "12px",
                        }),
                        option: (provided, state) => ({
                            ...provided,
                            fontSize: "12px",
                            color: state.isSelected ? "#ffffff" : "#707070",
                            backgroundColor: state.isSelected ? "#2576bc" : state.isFocused ? "#ffffff" : "#fff",
                            cursor: "pointer",
                            "&:hover": { backgroundColor: "#2576bc", color: "#fff" },
                        }),
                    }}
                />

                <hr className="field-cont-hr" />
            </div>
        </>
    );
};

export { DateRangePicker, LetterStatus, LetterType, SubCompany, Projects, ContractorFilter }
